<template>
  <img :src="imageSrc" :alt="alt" v-intersected="lazyLoad" :style="{opacity: loaded ? 1 : 0}">
</template>

<style lang="scss" scoped>
img {
  transition: opacity 0.3s linear;
}
</style>

<script>
export default {
  props: {
    initialImage: {
      type: String,
      default: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
    },
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      imageSrc: this.initialImage,
      loaded: false
    }
  },
  methods: {
    lazyLoaded () {
      this.loaded = true
      this.$emit('lazy-loaded')
    },
    lazyLoad (el, entry, observer) {
      this.imageSrc = this.src
      this.$el.addEventListener('load', this.lazyLoaded)
      observer.unobserve(this.$el)
    }
  }
}
</script>
